import { getAuth } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
// import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG!);

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);
const firebaseAuth = getAuth(firebaseApp);
const storage = getStorage(firebaseApp);
const functions = getFunctions(firebaseApp);
// const analytics = getAnalytics(app);

// connectFunctionsEmulator(functions, 'localhost', 5001);

export { db, storage, functions, firebaseApp, firebaseAuth };
